import { PlusOutlined } from "@ant-design/icons";
import { Modal, Upload } from "antd";
import type { RcFile, UploadProps } from "antd/es/upload";
import type { UploadFile } from "antd/es/upload/interface";
import { FC, useEffect, useState } from "react";
import { UploadImagesProps } from "./interface";
import { useAppSelector } from "store";
import { backendUrl } from "config";

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const AvataUpload: FC<UploadImagesProps> = ({
  maximumUploadItems,
  disabled,
  isEdit,
  value,
  allowFileExtensions,
  onChange,
}) => {
  const accessTokenKey = useAppSelector((state) => state.auth.accessToken);

  // console.log("value--->", value);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState<UploadFile[] | undefined>([]);
  const [newUpload, setNewUpload] = useState<Boolean>(false);

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1)
    );
  };

  useEffect(() => {
    if (value && !newUpload) {
      setFileList(value);
    }
  }, [value]);

  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    setNewUpload(true);

    const newFileListUrl = newFileList.map((item) => {
      //   console.log("item response->",item.response);
      if (item.response) {
        return {
          url: item.response?.url,
          id: item.response?.id,
        };
      }
      return {
        id: item.uid,
      };
    });
    onChange?.(newFileListUrl);
  };

  const uploadButton = (
    <div>
      <PlusOutlined style={{ color: "#417B97" }} />
      <div style={{ marginTop: 8, color: "#417B97" }}>เพิ่มรูปภาพ</div>
    </div>
  );
  return (
    <>
      <Upload
        style={{ borderRadius: 75 }}
        className="avatar-uploader"
        disabled={disabled}
        action={`${backendUrl}images/upload?type=product`}
        listType="picture-circle"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        maxCount={maximumUploadItems}
        accept={allowFileExtensions}
        headers={{
          Authorization: `Bearer ${accessTokenKey}`,
        }}
      >
        {fileList && fileList.length >= maximumUploadItems
          ? null
          : uploadButton}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  );
};

export default AvataUpload;

{
  /* <>
<Upload
  style={{ borderRadius: 75 }}
  disabled={disabled}
  className="avatar-uploader"
  action={`${backendUrl}/auth/profile/image`}
  listType="picture-circle"
  fileList={fileList}
  onPreview={handlePreview}
  onChange={handleChange}
  maxCount={maximumUploadItems}
  accept={allowFileExtensions}
  headers={{
    Authorization: `Bearer ${accessTokenKey}`,
  }}
>
  {fileList && fileList.length >= maximumUploadItems
    ? null
    : uploadButton}
</Upload>
<Modal
  open={previewOpen}
  title={previewTitle}
  footer={null}
  onCancel={handleCancel}
>
  <img alt="example" style={{ width: "100%" }} src={previewImage} />
</Modal>
</> */
}
